import { render, staticRenderFns } from "./DemandeInscriptionPsychotherapeute.vue?vue&type=template&id=48ded520"
import script from "./DemandeInscriptionPsychotherapeute.vue?vue&type=script&lang=js"
export * from "./DemandeInscriptionPsychotherapeute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports